const showHideProducts = {
  cats: document.querySelectorAll(".jsShowHideProd") as NodeListOf<HTMLElement>,
  prods: document.querySelectorAll(".jsSdlBox") as NodeListOf<HTMLElement>,

  init() {
    this.setCats();
  },
  setCats() {
    this.cats.forEach((item, index) => {
      const id = item.dataset.id as string;
      if (index === 0) {
        this.reset();
        this.setProds(id);
        item.classList.add("activeClass");        
      }
      item.addEventListener("click", () => {
        this.reset();
        this.setProds(id);
        item.classList.add("activeClass");
      });
    });
  },
  setProds(id: string) {
    this.prods.forEach((item) => {
      const cat = item.dataset.cat;
      if (cat === id) {
        item.classList.remove("d-none");
      }
    });
  },
  reset() {
    this.cats.forEach((item) => item.classList.remove("activeClass"));
    this.prods.forEach((item) => item.classList.add("d-none"));
  },
};

export default showHideProducts;
